import { updatesItems } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-12 md:py-16 bg-background-100/70">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 tracking-wide">
            最新动态
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-lg mx-auto">
            实时掌握51影院内容更新与系统优化动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-200/70">
            {updatesItems.map((item, idx) => (
              <div
                key={idx}
                className={`relative pb-6 md:pb-7 ${
                  idx === updatesItems.length - 1 ? 'pb-0' : ''
                }`}
              >
                <div className="absolute -left-[29px] md:-left-[31px] top-0 w-4 h-4 rounded-full bg-primary-500 border-2 border-background-50"></div>

                <div className="flex flex-col gap-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span
                      className={`px-2 py-0.5 text-xs rounded font-medium whitespace-nowrap ${
                        item.tag === '剧集更新' || item.tag === '动漫更新'
                          ? 'bg-primary-100 text-primary-700'
                          : item.tag === '新片入库' || item.tag === '剧集入库'
                          ? 'bg-accent-100 text-accent-700'
                          : item.tag === '完结播出'
                          ? 'bg-secondary-100 text-secondary-700'
                          : 'bg-background-200 text-foreground-600'
                      }`}
                    >
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-500">{item.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mt-1">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}